var map = {
	"./drockerhof-logo-de.webp": 6117,
	"./drockerhof-logo-en.webp": 7657,
	"./drockerhof-logo-it.webp": 9163,
	"./funes-logo.webp": 5393,
	"./furchetta-logo.webp": 3034,
	"./guest-pass-logo.webp": 1552,
	"./organic-logo.webp": 2901,
	"./slow-food-logo.webp": 8906,
	"./suedtirol-logo.webp": 8871
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6398;